module.exports = __webpack_public_path__ + "img/HIDE.7648f7ff.svg";